import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/checker/settings';

export default new class CheckingSettingModel {

  get() {    
    return new Promise((resolve, reject) => {      
      axios
        .get(BASE + '/findOne', {
          params: {
            access_token: UserModel.getAccessToken()
          }
        })
        .then((response) => {               
          resolve(response.data); 
        })
        .catch((error) => {
          reject(error);
        });      
    });    
  }

  update(id, data) {
    return new Promise((resolve, reject) => {      
      axios
        .put(BASE + '/' + id, data, {
          params: {
            access_token: UserModel.getAccessToken()
          }
        })
        .then((response) => {               
          resolve(response.data.Data); 
        })
        .catch((error) => {
          reject(error);
        });      
    });    
  }

}


// WEBPACK FOOTER //
// ./src/components/CheckingSettingModel.js